import { Button, Flex, HStack, InvertTheme, Menu, MenuItems, Text } from '@stoplight/mosaic';
import React, { useMemo, useContext } from 'react';

import { EXAMPLE_SPECS } from '../constants';
import { GlobalContext } from '../context';

export const Navbar = () => {
  return (
    <>
      <InvertTheme>
        <Flex h="2xl" shrink={0} px={5} alignItems="center" bg="canvas-pure">
          <HStack w="1/3" alignItems="center" spacing={4}>
            <Text fontSize="lg" fontWeight="semibold" lineHeight="none">
              Qilin API Documentation
            </Text>

          </HStack>

          <Flex w="1/3" justifyContent="center">
            <SpecUrlInput />
          </Flex>

          <HStack w="1/3" flex={1} justifyContent="end">
            <Button as="a" appearance="minimal" target="__blank" href="https://qilin.cloud">
              Qilin.Cloud
            </Button>
          </HStack>
        </Flex>
      </InvertTheme>
    </>
  );
};

const SpecUrlInput = () => {
  return <ExamplePicker />;
};

const ExamplePicker = () => {
  const { apiDescriptionUrl, setDescriptionUrl } = useContext(GlobalContext);

  const menuItems = useMemo(() => {
    const items: MenuItems = [
      {
        type: 'option_group',
        value: apiDescriptionUrl,
        onChange: setDescriptionUrl,
        children: EXAMPLE_SPECS.map(s => ({
          title: s.text,
          value: s.value,
        })),
      },
    ];

    return items;
  }, [apiDescriptionUrl, setDescriptionUrl]);

  const selectedTitle = useMemo(() => {
    const found = EXAMPLE_SPECS.find(s => s.value === apiDescriptionUrl);
    return found?.text ?? 'Pick an Example';
  }, [apiDescriptionUrl]);

  // Wrap the trigger in a fixed-width container and make the trigger full width
  // so the button and dropdown have matching widths while remaining centered.
  return (
    <Flex>
      <Menu
        closeOnPress
        aria-label="Example Picker Menu"
        items={menuItems}
        renderTrigger={({ isOpen }) => (
          <Button w="full" iconRight={['fas', 'caret-down']} active={isOpen}>
            {selectedTitle}
          </Button>
        )}
      />
    </Flex>
  );
};
